import { connect } from "react-redux";
import { providerLogin } from "../actions";
import LoginWithOauth from "../components/login-with-provider.jsx";
import { currentUser } from "../selectors";

const mapStateToProps = (state) => ({
  isLoading: state.auth.providerLogin.isProviderLoading,
  currentUser: currentUser(state),
});

export default connect(mapStateToProps, { providerLogin: providerLogin.request })(LoginWithOauth);
